import React from 'react';
import PropTypes from 'prop-types';
import QualifiedPlayersListingItem from './QualifiedPlayersListingItem';

export default class QualifiedPlayersListingContent extends React.PureComponent {
    render() {
        const isEmpty = this.props.isInitialRequestFulfilled && this.props.items.length === 0;

        return (
            <div className="qualified-players-listing__content">
                <div className="container" tabIndex="0" data-content aria-live="polite">
                    {!isEmpty > 0 ?
                        <ul className={'qualified-players-listing__grid'}>
                            {this.props.items.map((item, i) =>
                                <QualifiedPlayersListingItem index={i} item={item} key={item.id}/>)}
                        </ul> : (
                            <div className="qualified-players-listing__empty-result-container">
                                <div>
                                    <p>No results.</p>
                                    <p>Please try making your search a little wider</p>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

QualifiedPlayersListingContent.propTypes = {
    items: PropTypes.array.isRequired,
    isInitialRequestFulfilled: PropTypes.bool.isRequired,
};
